import { useLabelVersion } from '../../../features/labels/LabelsProvider';
import { labelId } from '../../../features/labels/labels';
import React, { useState } from 'react';
import { Grid, Tooltip, Button, Slide, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './Charts/styles/Dashboard.css'
const HoverCards = ({ open, data,  selectedDay: propSelectedDay, selectedCage, viewMode, nivelSeleccionado, translate }) => {
  useLabelVersion();
  const t = (key, fallback, params) => {
    const value = typeof translate === 'function' ? translate(key, params) : key;
    return value && value !== key ? value : fallback;
  };
  // Estado para controlar la visibilidad del panel desplegable
  // const [open, setOpen] = useState(false);
  // const togglePanel = () => {
  //   setOpen(prev => !prev);
  // };


  // //console.log('nivelSeleccionado',nivelSeleccionado)
  // //console.log('data',data)

  // Convertir el objeto de jaulas a un array (si data no existe, usar objeto vacío)
  // const jaulasArray = Object.keys(data || {}).map(key => ({ id: key, ...data[key] }));
  // Process data for 'centro' or 'area'
 // Transformar los datos según el nivel seleccionado
  let jaulasArray = [];
  if (nivelSeleccionado === 'area') {
    // data tiene estructura { centro: { area: { tasa_summary, values_summary } } }
    jaulasArray = Object.entries(data || {}).flatMap(([centroId, centroObj]) =>
      Object.entries(centroObj).map(([cageId, cageData]) => ({
        id: cageId,
        // Obtener name como segmento después del segundo guión
        name: cageId.split('-')[2] || cageId,
        label: labelId(cageId, 'rac', cageId.split('-')[2] || cageId),
        values_summary: Object.entries(cageData.values_summary || {}).map(([day, value]) => ({
          day,
          value
        }))
      }))
    );
  } else {
    // Nivel 'centro' u otros: estructura original de data
    jaulasArray = Object.keys(data || {}).map(key => ({
      id: key,
      ...data[key]
    }));
  }

  // --- Obtener todos los días desde values_summary de todas las jaulas ---
  const allDays = Array.from(
    new Set(
      (jaulasArray || [])
        .flatMap(j => (j.values_summary || []).map(v => v.day))
        .filter(Boolean)
    )
  ).sort((a, b) => new Date(a) - new Date(b));

  // --- Función para convertir 'dd/MM/yyyy' a Date ---
  const parseDDMMYYYY = (dateStr) => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  // --- Ordenar las fechas correctamente ---
  allDays.sort((a, b) => parseDDMMYYYY(a) - parseDDMMYYYY(b));

  // --- Formatear rango de fechas ---
  let rangoDiasTexto = "";
  if (allDays.length > 0) {
    const inicio = parseDDMMYYYY(allDays[0]).toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "short"
    });
    const fin = parseDDMMYYYY(allDays[allDays.length - 1]).toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "short"
    });
    rangoDiasTexto = `${inicio} - ${fin}`;
  }



  // Si viewMode es 'day', se usan todas las jaulas; 
  // solo en 'week' se filtra según selectedCage
  // Filtrar según viewMode y selectedCage (agregamos validación de existencia)
  const filteredJaulas = viewMode === 'day'
    ? jaulasArray
    : (selectedCage ? jaulasArray.filter(jaula => jaula?.name === selectedCage) : jaulasArray);

  // Obtener los días disponibles del feeding_time_range, validando que existan
  const availableDays =
    filteredJaulas.length > 0 && filteredJaulas[0]?.feeding_time_range
      ? filteredJaulas[0].feeding_time_range.map(entry => entry.day)
      : [];

  // Determinar el día seleccionado para el modo 'day'
  const selectedDay = viewMode === 'day'
    ? (propSelectedDay || (availableDays[0] || ""))
    : "";

  // Definir el título dependiendo del modo y si hay jaula seleccionada
  const title = viewMode === 'week'
    ? `${t('ranges_for', 'Rangos de')} ${jaulasArray.find((j) => j.name === selectedCage)?.label ?? (selectedCage || rangoDiasTexto)}`
    : `${t('ranges_day', 'Rangos del día')} ${selectedDay}`;

  // Función para formatear hora a partir de una cadena ISO
  const formatTime = (isoString) => {
    if (!isoString) return null;
    const date = new Date(isoString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // CARD 1: Rango Horario de Alimentación

let earliestFeeding = null;
let latestFeeding  = null;

if (nivelSeleccionado === 'area') {
  // A) Extraigo todos los summaries
  const summaries = Array.isArray(jaulasArray)
    ? jaulasArray.flatMap(c => c.values_summary || [])
    : [];

  // B) Si estoy en vista “day”, filtro por selectedDay; si “week”, cojo todos
  const filteredByDay = summaries.filter(s => {
    if (viewMode === 'day') {
      // Asegúrate de que selectedDay tenga el mismo formato que s.day
      return s.day === selectedDay
        && s.value?.feeding_time_range?.inicio?.hora
        && s.value?.feeding_time_range?.fin?.hora;
    } else if (viewMode === 'week') {
      return s.value?.feeding_time_range?.inicio?.hora
          && s.value?.feeding_time_range?.fin?.hora;
    }
    return false;
  });

  // C) Ahora mapeo inicios y fines sobre el subset correcto
  const inicioTimes = filteredByDay.map(s => {
    const fullName = s.value.feeding_time_range.inicio.jaula;
    const parts    = fullName.split('-');
    const name     = labelId(fullName, 'rac', parts.slice(2).join('-'));
    return { name, time: s.value.feeding_time_range.inicio.hora };
  });

  const finTimes = filteredByDay.map(s => {
    const fullName = s.value.feeding_time_range.fin.jaula;
    const parts    = fullName.split('-');
    const name     = labelId(fullName, 'rac', parts.slice(2).join('-'));
    return { name, time: s.value.feeding_time_range.fin.hora };
  });

  // D) Reducimos sólo si tenemos al menos un elemento
  if (inicioTimes.length > 0) {
    const e = inicioTimes.reduce((a, b) =>
      new Date(a.time) < new Date(b.time) ? a : b
    );
    earliestFeeding = { name: e.name, inicio: e.time };
  }
  if (finTimes.length > 0) {
    const l = finTimes.reduce((a, b) =>
      new Date(a.time) > new Date(b.time) ? a : b
    );
    latestFeeding = { name: l.name, final: l.time };
  }

} else {
  // --- Nivel Centro: tu lógica actual que recorre filteredJaulas ---
  const feedingTimes = [];
  filteredJaulas.forEach(jaula => {
    const feedingTimeRange = Array.isArray(jaula?.feeding_time_range)
      ? jaula.feeding_time_range
      : [];
    const entries = feedingTimeRange.filter(entry => {
      if (viewMode === 'day') {
        return entry.day === selectedDay &&
               entry?.value?.inicio &&
               entry?.value?.final;
      } else if (viewMode === 'week') {
        return entry?.value?.inicio && entry?.value?.final;
      }
      return false;
    });
    entries.forEach(entry => {
      feedingTimes.push({
        name: jaula?.label ?? (jaula?.name || t('no_name', 'Sin nombre')),
        day: entry.day,
        inicio: entry.value.inicio,
        final: entry.value.final
      });
    });
  });

  if (feedingTimes.length > 0) {
    earliestFeeding = feedingTimes.reduce((prev, current) =>
      new Date(prev.inicio) < new Date(current.inicio) ? prev : current
    );
    latestFeeding = feedingTimes.reduce((prev, current) =>
      new Date(prev.final) > new Date(current.final) ? prev : current
    );
  }
}
  // const feedingTimes = [];
  // filteredJaulas.forEach(jaula => {
  //   // Verificamos que feeding_time_range exista y sea un array
  //   const feedingTimeRange = Array.isArray(jaula?.feeding_time_range) ? jaula.feeding_time_range : [];
  //   const entries = feedingTimeRange.filter(entry => {
  //     if (viewMode === 'day') {
  //       return entry.day === selectedDay &&
  //              entry?.value?.inicio &&
  //              entry?.value?.final;
  //     } else if (viewMode === 'week') {
  //       return entry?.value?.inicio && entry?.value?.final;
  //     }
  //     return false;
  //   });
  //   entries.forEach(entry => {
  //     feedingTimes.push({
  //       name: jaula?.name || 'Sin nombre',
  //       day: entry.day,
  //       inicio: entry.value.inicio,
  //       final: entry.value.final
  //     });
  //   });
  // });

  // let earliestFeeding = null;
  // let latestFeeding = null;
  // if (feedingTimes.length > 0) {
  //   earliestFeeding = feedingTimes.reduce((prev, current) =>
  //     new Date(prev.inicio) < new Date(current.inicio) ? prev : current
  //   );
  //   latestFeeding = feedingTimes.reduce((prev, current) =>
  //     new Date(prev.final) > new Date(current.final) ? prev : current
  //   );
  // }

  // Variables para Cards 2, 3 y 4
  let minDelivered = null;
  let maxDelivered = null;
  let minAlarms = null;
  let maxAlarms = null;
  let minVisitas = null;
  let maxVisitas = null;

  if (viewMode === 'week' && selectedCage && filteredJaulas.length > 0) {
    // Solo se espera una jaula seleccionada en filteredJaulas
    const selectedJaula = filteredJaulas[0];
    const summary = Array.isArray(selectedJaula?.values_summary) ? selectedJaula.values_summary : [];

    if (summary.length > 0) {
      // Para Alimento Entregado:
      minDelivered = summary.reduce((prev, cur) =>
        (cur?.value?.delivered_food ?? Infinity) < (prev?.value?.delivered_food ?? Infinity) ? cur : prev,
        summary[0]
      );
      maxDelivered = summary.reduce((prev, cur) =>
        (cur?.value?.delivered_food ?? -Infinity) > (prev?.value?.delivered_food ?? -Infinity) ? cur : prev,
        summary[0]
      );

      // Para Alarmas:
      minAlarms = summary.reduce((prev, cur) =>
        (cur?.value?.alarms_count ?? Infinity) < (prev?.value?.alarms_count ?? Infinity) ? cur : prev,
        summary[0]
      );
      maxAlarms = summary.reduce((prev, cur) =>
        (cur?.value?.alarms_count ?? -Infinity) > (prev?.value?.alarms_count ?? -Infinity) ? cur : prev,
        summary[0]
      );

      // Para Visitas:
      minVisitas = summary.reduce((prev, cur) =>
        (cur?.value?.visitas_count ?? Infinity) < (prev?.value?.visitas_count ?? Infinity) ? cur : prev,
        summary[0]
      );
      maxVisitas = summary.reduce((prev, cur) =>
        (cur?.value?.visitas_count ?? -Infinity) > (prev?.value?.visitas_count ?? -Infinity) ? cur : prev,
        summary[0]
      );
    }
  } else {
    // Lógica para modo 'day' o modo 'week' sin jaula seleccionada (valores acumulados)
    const deliveredFoodData = filteredJaulas.map(jaula => {
      let total = 0;
      const summary = Array.isArray(jaula?.values_summary) ? jaula.values_summary : [];
      if (viewMode === 'day') {
        const entry = summary.find(item => item.day === selectedDay);
        total = entry ? (entry?.value?.delivered_food || 0) : 0;
      } else if (viewMode === 'week') {
        total = summary.reduce((sum, item) => sum + (item?.value?.delivered_food || 0), 0);
      }
      return {
        name: jaula?.label ?? (jaula?.name || t('no_name', 'Sin nombre')),
        value: total
      };
    });
    if (deliveredFoodData.length > 0) {
      minDelivered = deliveredFoodData.reduce((prev, current) =>
        current.value < prev.value ? current : prev
      );
      maxDelivered = deliveredFoodData.reduce((prev, current) =>
        current.value > prev.value ? current : prev
      );
    }

    const alarmsData = filteredJaulas.map(jaula => {
      let total = 0;
      const summary = Array.isArray(jaula?.values_summary) ? jaula.values_summary : [];
      if (viewMode === 'day') {
        const entry = summary.find(item => item.day === selectedDay);
        total = entry ? (entry?.value?.alarms_count || 0) : 0;
      } else if (viewMode === 'week') {
        total = summary.reduce((sum, item) => sum + (item?.value?.alarms_count || 0), 0);
      }
      return {
        name: jaula?.label ?? (jaula?.name || t('no_name', 'Sin nombre')),
        value: total
      };
    });
    if (alarmsData.length > 0) {
      minAlarms = alarmsData.reduce((prev, current) =>
        current.value < prev.value ? current : prev
      );
      maxAlarms = alarmsData.reduce((prev, current) =>
        current.value > prev.value ? current : prev
      );
    }

    const visitaData = filteredJaulas.map(jaula => {
      let total = 0;
      const summary = Array.isArray(jaula?.values_summary) ? jaula.values_summary : [];
      if (viewMode === 'day') {
        const entry = summary.find(item => item.day === selectedDay);
        total = entry ? (entry?.value?.visitas_count || 0) : 0;
      } else if (viewMode === 'week') {
        total = summary.reduce((sum, item) => sum + (item?.value?.visitas_count || 0), 0);
      }
      return {
        name: jaula?.label ?? (jaula?.name || t('no_name', 'Sin nombre')),
        value: total
      };
    });
    if (visitaData.length > 0) {
      minVisitas = visitaData.reduce((prev, current) =>
        current.value < prev.value ? current : prev
      );
      maxVisitas = visitaData.reduce((prev, current) =>
        current.value > prev.value ? current : prev
      );
    }
  }

  // Estilos para las tarjetas (cards)
  const cardHoverStyles = {
    maxWidth: '20vw',
    minWidth: '18vw',
    height: '15vh',
    marginTop: '1vh',
    overflow: 'hidden',
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
    // border:'solid 0.01vw'
  };

  // //console.log('jaula')

  // Tooltip: Se define de forma general para "day" ya que no tiene sentido incluir la jaula seleccionada en este modo
  const tooltipDefinition = viewMode === 'week'
    ? (selectedCage
        ? t(
            'range_description_week_selected',
            'Se comparan los valores diarios de la jaula seleccionada para identificar sus mínimos y máximos.'
          )
        : t(
            'range_description_week_all',
            'Se comparan los valores acumulados semanales por jaula para identificar sus mínimos y máximos.'
          ))
    : t(
        'range_description_day',
        'Se comparan los valores diarios por jaula para identificar sus mínimos y máximos.'
      );

  return (
    <>
      {/* <Button
        variant="extended"
        color="default"
        onClick={togglePanel}
        style={{
          position: 'fixed',
          top:'2vh',
          left: '22vw',
          zIndex: 1100,
          borderRadius:'0.5vw',
          backgroundColor: 'transparent',
          border: 'solid 0.1vh #e94e1a',
          color: '#c3c3c3',
          fontSize: '0.7vw',
          height: '4vh',
          width: '6vw',
        }}
      >
        Rangos {open ? <ExpandLessIcon style={{ fontSize:'1vw', marginRight: '0.5vw' }} /> : <ExpandMoreIcon style={{ fontSize:'1vw', marginRight: '0.5vw' }} />}

      </Button> */}
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Grid container alignItems="center" alignContent={'center'}
        className='card'
          sx={{
            position: 'fixed',
            // display:'flex',
            // justifyContent:'center',
            bottom: 0,
            left: '10vw',
            width: '80vw',
            height: '25vh',
            bgcolor: '#000000',
            zIndex: 1000,
            overflowY: 'hidden',
            padding: 2,
          }}
        >
          <Grid container direction="column" alignContent={'center'} alignItems={'center'} style={{ background: '#000000' }}>
            {/* Título dinámico */}
            <Grid container justifyContent="center" alignContent={'center'} alignItems={'center'} style={{ marginBottom: '0vh', marginTop:'-2vh' }}>
              <h2 className='h2' style={{ color: '#c3c3c3' }}>{title}</h2> 
              <Tooltip title={tooltipDefinition} placement="top" componentsProps={tooltipStyle} sx={{ fontSize: '1.8vh' }}>
                <InfoIcon style={{ color: '#a6a6a6', cursor: 'pointer',  marginLeft:'0.6vw' }} />
              </Tooltip>
            </Grid>
            <Grid container justifyContent="space-around"  alignContent={'center'} alignItems={'center'}>
              {/* Card 1: Rango Horario de Alimentación */}
              <Grid item>
                <div className="card" style={cardHoverStyles}>
                  <h2 className='h2'>{t('feeding_schedule', 'Horario de alimentación')}</h2>
                  <div style={{marginTop: '-2vh', height:'4vh',display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <h3 className='h3' style={{ height: '3vh' }}>
                      {earliestFeeding
                        ? `${t('inicio', 'Inicio')}: ${formatTime(earliestFeeding.inicio)} - ${earliestFeeding.name}`
                        : t('no_data', 'No hay datos')}
                    </h3>
                     <h3 className='h3'>
                      {latestFeeding
                        ? `${t('fin', 'Fin')}: ${formatTime(latestFeeding.final)} - ${latestFeeding.name}`
                        : t('no_data', 'No hay datos')}
                    </h3>
                  </div>
                  
                </div>
              </Grid>

              {/* Card 2: Rangos de Alimento Entregado */}
              <Grid item>
                <div className="card" style={cardHoverStyles}>
                  <h2 className='h2'>
                    {viewMode === 'week' && !selectedCage
                      ? `${t('delivered_food', 'Alimento entregado')} ${t('accumulated', 'Acumulado')}`
                      : t('delivered_food', 'Alimento entregado')}
                  </h2>
                  <div style={{marginTop: '-2vh', height:'4vh',  display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <h3 className='h3' style={{ height: '3vh' }}>
                      {minDelivered ? (
                        viewMode === 'week' && selectedCage
                          ? `${t('min', 'Min')}: ${(minDelivered?.value?.delivered_food ?? 0).toFixed(2)} [Kg] - ${selectedCage} - ${t('day', 'Día')}: ${minDelivered?.day || 'N/A'}`
                          : `${t('min', 'Min')}: ${(minDelivered?.value ?? 0).toFixed(2)} [Kg] - ${minDelivered?.name || 'N/A'}`
                      ) : t('no_data', 'No hay datos')}
                    </h3>
                    <h3 className='h3'>
                      {maxDelivered ? (
                        viewMode === 'week' && selectedCage
                          ? `${t('max', 'Max')}: ${(maxDelivered?.value?.delivered_food ?? 0).toFixed(2)} [Kg] - ${selectedCage} - ${t('day', 'Día')}: ${maxDelivered?.day || 'N/A'}`
                          : `${t('max', 'Max')}: ${(maxDelivered?.value ?? 0).toFixed(2)} [Kg] - ${maxDelivered?.name || 'N/A'}`
                      ) : t('no_data', 'No hay datos')}
                    </h3>
                  </div>
                </div>
              </Grid>

              {/* Card 3: Rangos de Alarmas */}
              <Grid item>
                <div className="card" style={cardHoverStyles}>
                  <h2 className='h2'>
                    {viewMode === 'week' && !selectedCage
                      ? `${t('alarms', 'Alarmas')} ${t('accumulated', 'Acumuladas')}`
                      : t('alarms', 'Alarmas')}
                  </h2>
                  <div style={{marginTop: '-2vh', height:'4vh', display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <h3 className='h3' style={{ height: '3vh' }}>
                      {minAlarms ? (
                        viewMode === 'week' && selectedCage
                          ? `${t('min', 'Min')}: ${minAlarms?.value?.alarms_count || 0} - ${selectedCage} - ${t('day', 'Día')}: ${minAlarms?.day || 'N/A'}`
                          : `${t('min', 'Min')}: ${minAlarms?.value || 0} - ${minAlarms?.name || 'N/A'}`
                      ) : t('no_data', 'No hay datos')}
                    </h3>
                    <h3 className='h3'>
                      {maxAlarms ? (
                        viewMode === 'week' && selectedCage
                          ? `${t('max', 'Max')}: ${maxAlarms?.value?.alarms_count || 0} - ${selectedCage} - ${t('day', 'Día')}: ${maxAlarms?.day || 'N/A'}`
                          : `${t('max', 'Max')}: ${maxAlarms?.value || 0} - ${maxAlarms?.name || 'N/A'}`
                      ) : t('no_data', 'No hay datos')}
                    </h3>
                  </div>
                </div>
              </Grid>

              {/* Card 4: Rangos de Visitas */}
              <Grid item>
                <div className="card" style={cardHoverStyles}>
                  <h2 className='h2'>
                    {viewMode === 'week' && !selectedCage
                      ? `${t('visits', 'Visitas')} ${t('accumulated', 'Acumuladas')}`
                      : t('visits', 'Visitas')}
                  </h2>
                  <div style={{marginTop: '-2vh', height:'4vh', display:'flex', justifyContent:'center', flexDirection:'column'}}>
                    <h3 className='h3' style={{ height: '3vh' }}>
                      {minVisitas ? (
                        viewMode === 'week' && selectedCage
                          ? `${t('min', 'Min')}: ${minVisitas?.value?.visitas_count || 0} - ${selectedCage} - ${t('day', 'Día')}: ${minVisitas?.day || 'N/A'}`
                          : `${t('min', 'Min')}: ${minVisitas?.value || 0} - ${minVisitas?.name || 'N/A'}`
                      ) : t('no_data', 'No hay datos')}
                    </h3>
                    <h3 className='h3'>
                      {maxVisitas ? (
                        viewMode === 'week' && selectedCage
                          ? `${t('max', 'Max')}: ${maxVisitas?.value?.visitas_count || 0} - ${selectedCage} - ${t('day', 'Día')}: ${maxVisitas?.day || 'N/A'}`
                          : `${t('max', 'Max')}: ${maxVisitas?.value || 0} - ${maxVisitas?.name || 'N/A'}`
                      ) : t('no_data', 'No hay datos')}
                    </h3>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Slide>
    </>
  );
};

export default HoverCards;

const tooltipStyle = {
  tooltip: {
    sx: {
      fontSize: '1.1vh'
    }
  }
};
